import { useState } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CancelIcon2, RoundedTickIcon } from "../../icons/Icon";
import Button from "../Dealers/Button";
import { useToast } from "../Toaster/Toaster";
import VerticalDropDown2 from "../FormComponents/VerticalDropDown2";

const RequestForCancelModal = ({
  handleCloseModal,
  mode,
  handleSubmit,
  type = "dispatch",
  uniqueWarehouses,
}) => {
  const { show } = useToast();
  const [reason, setReason] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState({
    label: "Select",
    value: "Select",
  });

  // console.log("selectedWarehouse ", selectedWarehouse);

  const handleClick = () => {
    if (reason === "") {
      show("The reason must be greater than 20 characters!", "warning");
    } else if (selectedWarehouse.label === "Select" && type === "order") {
      show("Select a warehouse to cancel the order!", "warning");
    } else {
      handleSubmit(reason, selectedWarehouse.value);
      handleCloseModal();
    }
  };

  return (
    <div
      className={styles.req_for_cancel}
      style={mode ? { backgroundColor: "#232529" } : {}}
    >
      <p style={mode ? { color: "#FFFFFF" } : {}}>Request for Cancel</p>
      {type === "order" && (
        <div className={styles.column}>
          <p style={mode ? { color: "#FFFFFF" } : {}}>
            Select warehouse to cancel
          </p>
          <VerticalDropDown2
            height={"37px"}
            fontSize={"12px"}
            dropDownText={"Select"}
            value={selectedWarehouse}
            options={uniqueWarehouses.map((w) => ({
              label: w.label,
              value: w.value,
            }))}
            onchange={(option) => {
              setSelectedWarehouse(option);
            }}
          />
        </div>
      )}
      <div className={styles.column}>
        <p style={mode ? { color: "#FFFFFF" } : {}}>
          Enter the reason why you need to cancel this order
        </p>
        <textarea
          name=""
          id=""
          placeholder="*minimun 20 characters"
          required
          rows="4"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className={`${styles.textarea} ${mode ? styles.textarea_dark : ""}`}
        ></textarea>
      </div>
      <div className={styles.req_for_cancel_btns}>
        <Button
          buttonIcon={<CancelIcon2 />}
          buttonText={"Cancel"}
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonClick={handleCloseModal}
        />
        <Button
          buttonIcon={<RoundedTickIcon />}
          buttonText={"Submit"}
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#FFFFFF"}
          buttonClick={handleClick}
        />
      </div>
    </div>
  );
};

export default RequestForCancelModal;
